import {
  Box,
  Cloud,
  Database,
  HardDrive,
  Mail,
  Package,
  Phone,
  Server,
  ShieldCheck,
  Terminal,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Lucide-Icon-Mapping pro Service-Type-Slug bzw. Family-Fallback.
 *
 * Wir bewusst kein Bilder-Asset (Vendor-Logos), weil:
 *   - Lokales Single-User-Tool ohne CDN-Caching (Bundle-Bloat).
 *   - Lucide ist konsistent mit dem restlichen UI-Look.
 *   - Trademark-Risiken (z.B. Proxmox-Logo) entfallen.
 *
 * Falls Pflege-Aufwand zu hoch wird: Map per ServiceType-Family kollabieren.
 */

const ICON_BY_SLUG: Record<string, LucideIcon> = {
  opnsense: ShieldCheck,
  pfsense: ShieldCheck,
  'proxmox-ve': Server,
  'proxmox-bs': HardDrive,
  proxmox: Server,
  nextcloud: Cloud,
  freepbx: Phone,
  asterisk: Phone,
  debian: Terminal,
  ubuntu: Terminal,
  postgres: Database,
  postgresql: Database,
  mysql: Database,
  mariadb: Database,
  mailcow: Mail,
  postfix: Mail,
};

const ICON_BY_FAMILY: Record<string, LucideIcon> = {
  firewall: ShieldCheck,
  hypervisor: Server,
  app: Package,
  mail: Mail,
  telephony: Phone,
  os: Terminal,
  backup: HardDrive,
  db: Database,
};

export function iconForServiceType(slug: string | null | undefined, family?: string | null): LucideIcon {
  if (slug && ICON_BY_SLUG[slug]) return ICON_BY_SLUG[slug];
  if (family && ICON_BY_FAMILY[family]) return ICON_BY_FAMILY[family];
  return Box;
}
